// extracted by mini-css-extract-plugin
export default {"app":"Global_app__cHBbN","body":"Global_body__eQrWi","bottom":"Global_bottom__axZtQ"};